import { MessageSquare, X } from "lucide-react"
export default function ChatTrigger({ style, open, setOpen, triggerRef, brand_color, button_type }: { style?: React.CSSProperties, open: boolean, setOpen: Function, triggerRef: React.RefObject<HTMLButtonElement | null>, brand_color?: string, button_type?: string }) {

    return (
        <button ref={triggerRef} style={{...style, backgroundColor: brand_color || style?.backgroundColor}}
            onClick={() => { setOpen(!open) }}
            onMouseDown={(e) => {
                e.preventDefault()
            }}
            className={"cl-trigger " + (button_type === "icon_text" ? "cl-trigger-text" : "")}>
            <X className={"cl-trigger-icon " + (open ? "cl-scale-100" : "cl-scale-0")} />
            <div className={"cl-trigger-content " + (open ? "cl-scale-0" : "cl-scale-100")}>
                <MessageSquare className="cl-trigger-icon-static" />
                {button_type === "icon_text" && <span className="cl-trigger-span">Help</span>}
            </div>
        </button>
    )
}
